/* Homepage: the pen visits stations, it never hangs around.
   1. hero -> flies into "Meet the pen" (callouts appear)
   2. "Meet the pen" -> flies into the highlighted starter kit card, becoming that kit's pen
   3. final call: the pen glides into place inside its card as the section scrolls in
   Between stations there is no extra pen on screen. Every position is a function of the
   scroll position, so scrolling back reverses it. */
(()=>{
const sec=document.querySelector('.pen-sec'),src=document.querySelector('.hero .float-pen');
if(!sec||!src)return;
const slot=sec.querySelector('.pen-slot');
const kits=[...document.querySelectorAll('.kits .kit')];
const fin=document.querySelector('.final'),fimg=fin&&fin.querySelector('.media img');
const RM=matchMedia('(prefers-reduced-motion: reduce)').matches||innerWidth<=700;
const tr=document.createElement('img');tr.className='pen-traveler';tr.src=src.currentSrc||src.src;tr.alt='';tr.setAttribute('aria-hidden','true');document.body.appendChild(tr);
let off=false,kitPen=null;
const show=el=>{if(el)el.style.visibility=''},hide=el=>{if(el)el.style.visibility='hidden'};
const still=()=>{off=true;sec.classList.add('static');sec.classList.remove('away');show(src);show(kitPen);tr.style.display='none';if(fin)fin.classList.remove('pen-wait');if(fimg)fimg.style.transform=''};
window.__penStatic=still;
if(RM){if(innerWidth<=700)src.style.animation='penIn 1.1s var(--ease-spring) .55s both';still();return}
if(fin)fin.classList.remove('pen-wait');

const cl=v=>Math.min(1,Math.max(0,v));
const ease=t=>t<.5?4*t*t*t:1-Math.pow(-2*t+2,3)/2;
const easeOut=t=>1-Math.pow(1-t,3);
const wrap=document.querySelector('.page-wrapper');
const scroller=()=>wrap&&wrap.scrollHeight>wrap.clientHeight+1&&getComputedStyle(wrap).overflowY!=='visible'?wrap:null;
const sY=()=>{const w=scroller();return w?w.scrollTop:scrollY};
const maxY=()=>{const w=scroller();return w?w.scrollHeight-w.clientHeight:document.documentElement.scrollHeight-innerHeight};
/* layout box (untransformed size, visual centre) */
const box=(el,r)=>{const b=el.getBoundingClientRect();return{x:b.left+b.width/2,y:b.top+b.height/2,w:el.offsetWidth||b.width,h:el.offsetHeight||b.height,r:r||0}};
const rotOf=el=>{const m=(getComputedStyle(el).transform||'').match(/matrix\(([^)]+)\)/);if(!m)return 0;const a=m[1].split(',').map(parseFloat);return Math.atan2(a[1],a[0])*180/Math.PI};
const mix=(a,b,e,swing,tilt,es)=>{const arc=Math.sin(Math.PI*e);if(es===undefined)es=e;return{x:a.x+(b.x-a.x)*e-arc*swing,y:a.y+(b.y-a.y)*e,w:a.w+(b.w-a.w)*es,h:a.h+(b.h-a.h)*es,r:a.r+(b.r-a.r)*e+tilt*arc}};
let base=null;
const draw=s=>{if(!s){tr.style.display='none';return}
 if(!base){base=box(src);tr.style.width=base.w+'px';tr.style.height=base.h+'px'}
 const k=s.h/base.h;tr.style.display='block';
 tr.style.transform=`translate(${s.x-base.w/2}px,${s.y-base.h/2}px) rotate(${s.r}deg) scale(${k})`};

/* station 2 target: the highlighted kit, or on a swipe carousel the kit that is in view */
const pickKit=()=>{const vw=innerWidth;const inView=k=>{const r=k.getBoundingClientRect();return r.left>=-8&&r.right<=vw+8};
 const k=kits.find(k=>k.classList.contains('protocol')&&inView(k))||kits.find(inView)||kits[0];
 return k?k.querySelector('.media .pen'):null};
let kitR=null,finR=null;
/* station 3: the final pen's own transform, so it stays clipped by its card */
const finBase=()=>{if(finR===null)finR=rotOf(fimg);return finR};

let ticking=false;
const frame=()=>{ticking=false;if(off)return;
 const sy=sY(),vh=innerHeight,A=box(src),B=box(slot);
 const end=B.y+sy-vh*(parseFloat(sec.dataset.land)||.68);
 if(end<=40){still();return}
 /* 1. hero -> meet the pen */
 const p=cl(sy/end);sec.style.setProperty('--p',ease(p).toFixed(3));
 let s=null,away=false;
 if(p>0&&p<1)s=mix(A,B,ease(p),Math.min(120,innerWidth*.08),-14);
 /* 2. meet the pen -> kit card */
 const kp=pickKit();
 if(kp!==kitPen){show(kitPen);kitPen=kp;kitR=null}
 if(p>=1&&kitPen){
  if(kitR===null)kitR=rotOf(kitPen);
  const K=box(kitPen,kitR),s0=B.y+sy-vh*.2;let s1=K.y+sy-vh*.58;if(s1<s0+vh*.3)s1=s0+vh*.3;
  const t=cl((sy-s0)/(s1-s0));
  if(t>0){away=true;if(t<1)s=mix(B,K,ease(t),-50,10,easeOut(t))}
  if(t<1)hide(kitPen);else show(kitPen);
 }else if(kitPen)hide(kitPen);
 src.style.visibility=p>0?'hidden':'';
 sec.classList.toggle('landed',p>=1);sec.classList.toggle('away',away);
 /* 3. final: glide into place inside the card */
 if(fimg){const F=box(fimg),fEnd=Math.max(vh*.55,F.y+sy-maxY()+8),fStart=fEnd+vh*.7,q=easeOut(cl((fStart-F.y)/(fStart-fEnd)));
  const r=finBase(),dx=(1-q)*Math.min(320,innerWidth*.3),dy=(1-q)*-60,dr=(1-q)*24;
  fimg.style.transform=q>=1?'':`translate(-50%,-50%) translate(${dx.toFixed(1)}px,${dy.toFixed(1)}px) rotate(${(r+dr).toFixed(2)}deg)`}
 draw(s)};
const req=()=>{if(!ticking){ticking=true;requestAnimationFrame(frame)}};
document.addEventListener('scroll',req,{passive:true,capture:true});
document.querySelectorAll('.kits').forEach(k=>k.addEventListener('scroll',req,{passive:true}));
addEventListener('resize',()=>{base=null;kitR=null;finR=null;if(fimg)fimg.style.transform='';req()});
setTimeout(req,50);setTimeout(req,1800);
})();
